import { ReportColumnNames, ReportRowRawData } from '@qality/common-model';

import ReportTableService from '../utils/ReportTableService';

export const rows = (
  data: ReportRowRawData,
  columnNames: Array<ReportColumnNames>,
  columnKeys: Array<{ key: string; type: string }>
): JSX.Element => {
  const mapper = ReportTableService.getMapper(columnNames);

  return data.map<any>((row, index) => {
    let tableRow = row.map((cell, cellIndex) => {
      const columnIndex = columnNames.findIndex(
        (column) => column.key === columnKeys[cellIndex].key
      );
      if (columnIndex === -1) {
        return null;
      }
      return {
        index: columnIndex,
        component: mapper[columnIndex](cell),
      };
    });
    tableRow = tableRow
      .filter((tableCell) => tableCell != null)
      .sort((a, b) => a.index - b.index)
      .map((tableCell) => tableCell.component);

    return {
      key: `row-${index}`,
      cells: tableRow,
    };
  });
};
